<template>
  <!-- Add -->
  <div
    class="modal fade"
    id="add_item"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ isEditMode ? "Update" : "Create" }} {{ title }}
          </h5>
          <div class="d-flex align-items-center">
            <button
              class="btn-close custom-btn-close border p-1 me-0 text-dark"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i class="ti ti-x"></i>
            </button>
          </div>
        </div>
        <form @submit.prevent="submitForm">
          <div class="modal-body">
            <!-- Input Fields -->
            <div class="mb-3">
              <label class="col-form-label"
                >Name <span class="text-danger">*</span></label
              >
              <input type="text" class="form-control" v-model="name" />
              <div class="text-danger" v-if="errors.name">
                {{ errors.name[0] }}
              </div>
            </div>

            <div class="mb-3">
              <label class="col-form-label"
                >Country <span class="text-danger">*</span></label
              >
              <multiselect
                v-model="selectedCountry"
                :options="countries"
                track-by="name"
                label="name"
                placeholder="Select a country"
              >
              </multiselect>
            </div>
            <div class="mb-3">
              <label class="col-form-label"
                >Division <span class="text-danger">*</span></label
              >
              <multiselect
                v-model="selectedDivision"
                :options="divisions"
                track-by="name"
                label="name"
                placeholder="Select a division"
              >
              </multiselect>
            </div>
            <div class="mb-3">
              <label class="col-form-label"
                >District <span class="text-danger">*</span></label
              >
              <multiselect
                v-model="selectedDistrict"
                :options="districts"
                track-by="name"
                label="name"
                placeholder="Select a district"
              >
              </multiselect>
              <div class="text-danger" v-if="errors.district_id">
                {{ errors.district_id[0] }}
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="d-flex align-items-center justify-content-end m-0">
              <a href="#" class="btn btn-light me-2" data-bs-dismiss="modal"
                >Cancel</a
              >
              <button
                type="submit"
                class="btn btn-primary"
                :disabled="isLoading"
              >
                <span
                  v-if="isLoading"
                  class="spinner-border spinner-border-sm"
                ></span>
                {{ isEditMode ? "Update" : "Create" }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Add  -->

  <!-- Delete -->
  <div class="modal fade" id="delete_item" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="text-center">
            <div class="avatar avatar-xl bg-danger-light rounded-circle mb-3">
              <i class="ti ti-trash-x fs-36 text-danger"></i>
            </div>
            <h4 class="mb-2">Remove {{ title }}?</h4>
            <p class="mb-0">Are you sure you want to remove it</p>
            <div class="d-flex align-items-center justify-content-center mt-4">
              <a href="#" class="btn btn-light me-2" data-bs-dismiss="modal"
                >Cancel</a
              >
              <button
                class="btn btn-danger"
                @click="deleteItem()"
                :disabled="isLoading"
              >
                <span
                  v-if="isLoading"
                  class="spinner-border spinner-border-sm"
                ></span>
                Yes, Delete it
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete -->
</template>
<script>
import http from "@/utils/http";
import Multiselect from "vue-multiselect";

export default {
  components: { Multiselect },
  props: {
    isEditMode: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    isLoading: false,
    name: "",
    country_id: null,
    division_id: null,
    district_id: null,
    thana_id: null,
    itemId: null,
    errors: {},
    countries: [],
    selectedCountry: "",
    allDivisions: [],
    divisions: [],
    selectedDivision: "",
    allDistricts: [],
    districts: [],
    selectedDistrict: "",
  }),
  watch: {
    selectedCountry(newValue) {
      if (newValue) {
        this.getDivisionsByCountry();
      }
    },
    selectedDivision(newValue) {
      if (newValue) {
        this.getDistrictsByDivision();
      }
    },
  },

  mounted() {
    this.$emitter.on("add-edit-item", (row) => {
      this.getCountries();
      if (row) {
        this.itemId = row.id;
        this.name = row.name;
        this.selectedCountry = row.country_id;
        this.selectedDivision = row.division_id;
        this.selectedDistrict = row.district_id;
      }
      this.$handleModal("add_item", "toggle");
    });

    this.$emitter.on("delete-item-modal", (row) => {
      if (row) {
        this.itemId = row.id;
      }
      this.$handleModal("delete_item", "toggle");
    });
  },

  methods: {
    async submitForm() {
      this.isLoading = true;
      const endpoint = this.isEditMode ? `/zones/${this.itemId}` : "/zones";
      const method = this.isEditMode ? "put" : "post";
      let body = {
        name: this.name,
        district_id: this.selectedDistrict ? this.selectedDistrict.id : '',
      };
      try {
        const response = await http[method](endpoint, body);

        this.$toast.success(response.data.message);
        this.$handleModal("add_item", "hide");
        this.$emit("refresh");
      } catch (error) {
        this.errors = error.response.data.errors;
      } finally {
        this.isLoading = false;
      }
    },
    async deleteItem() {
      this.isLoading = true;
      const endpoint = `/zones/${this.itemId}`;
      const method = "delete";
      try {
        const response = await http[method](endpoint);
        this.$toast.success(response.data.message);
        this.$handleModal("delete_item", "hide");
        this.$emit("refresh");
      } catch (error) {
        this.$toast.error(error.response.data.message);
      } finally {
        this.isLoading = false;
      }
    },
    //get countries, divisions, districts, thanas
    async getCountries() {
      const endpoint = `/countries`;
      const method = "get";
      try {
        const response = await http[method](endpoint);
        this.countries = response.data.contents;
        if (this.selectedCountry != "") {
          const foundCountry = response.data.contents.find(
            (data) => data.id == this.selectedCountry
          );
          if (foundCountry) {
            this.selectedCountry = foundCountry;
          }
        }
      } catch (error) {
        //
      }
    },
    async getDivisionsByCountry() {
      this.divisions = [];
      const endpoint = `/divisions-by-country`;
      const method = "post";
      let body = {
        country_id: this.selectedCountry.id,
      };
      try {
        const response = await http[method](endpoint, body);
        this.divisions = response.data.contents;

        if (this.selectedDivision != "") {
          const foundDivision = this.divisions.find(
            (data) => data.id == this.selectedDivision
          );
          if (foundDivision) {
            this.selectedDivision = foundDivision;
          }
        }
      } catch (error) {
        //
      }
    },

    async getDistrictsByDivision() {
      this.districts = [];
      const endpoint = `/districts-by-division`;
      const method = "post";
      let body = {
        division_id: this.selectedDivision.id,
      };
      try {
        const response = await http[method](endpoint, body);
        this.districts = response.data.contents;

        if (this.selectedDistrict != "") {
          const foundDistrict = this.districts.find(
            (data) => data.id == this.selectedDistrict
          );
          if (foundDistrict) {
            this.selectedDistrict = foundDistrict;
          }
        }
      } catch (error) {
        //
      }
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
